import type { ConfigurationContextValue } from "./ConfigurationContext";

export const defaultDarkModeLogo = "/baskerville-favicon.png";
export const defaultLightModeLogo = "/baskerville-favicon.png";

export const defaultCurrency = "USD";

export const defaultTitle = "BaskervilleAI CRM";

export const defaultCompanySectors = [
  { value: "communication-services", label: "Servicios de comunicación" },
  { value: "consumer-discretionary", label: "Consumo discrecional" },
  { value: "consumer-staples", label: "Productos de consumo básico" },
  { value: "energy", label: "Energía" },
  { value: "financials", label: "Servicios financieros" },
  { value: "health-care", label: "Salud" },
  { value: "industrials", label: "Industria" },
  { value: "information-technology", label: "Tecnología de la información" },
  { value: "materials", label: "Materiales" },
  { value: "real-estate", label: "Bienes raíces" },
  { value: "utilities", label: "Servicios públicos" },
];

export const defaultDealStages = [
  { value: "opportunity", label: "Oportunidad" },
  { value: "proposal-sent", label: "Propuesta enviada" },
  { value: "in-negociation", label: "En negociación" },
  { value: "won", label: "Ganada" },
  { value: "lost", label: "Perdida" },
  { value: "delayed", label: "Aplazada" },
];

export const defaultDealPipelineStatuses = ["won"];

export const defaultDealCategories = [
  { value: "other", label: "Otra" },
  { value: "copywriting", label: "Redacción" },
  { value: "print-project", label: "Proyecto de impresión" },
  { value: "ui-design", label: "Diseño de interfaz" },
  { value: "website-design", label: "Diseño web" },
];

export const defaultNoteStatuses = [
  { value: "cold", label: "Frío", color: "#7dbde8" },
  { value: "warm", label: "Tibio", color: "#e8cb7d" },
  { value: "hot", label: "Caliente", color: "#e88b7d" },
  { value: "in-contract", label: "En contrato", color: "#a4e87d" },
];

export const defaultTaskTypes = [
  { value: "none", label: "Ninguno" },
  { value: "email", label: "Correo" },
  { value: "demo", label: "Demo" },
  { value: "lunch", label: "Almuerzo" },
  { value: "meeting", label: "Reunión" },
  { value: "follow-up", label: "Seguimiento" },
  { value: "thank-you", label: "Agradecimiento" },
  { value: "ship", label: "Envío" },
  { value: "call", label: "Llamada" },
];

export const defaultConfiguration: ConfigurationContextValue = {
  b2bSalesPool: [],
  companySectors: defaultCompanySectors,
  currency: defaultCurrency,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
};
